<template>
  <div class='warpper'>
    <div class='title'>
      <span> CyberMerit - 电子木鱼 </span>
    </div>

    <div class='main'>
      <img id='defaultImg' ref='defaultImg' :src='this.static_image_default' alt='default' @click='userClick'
        width='600' />
      <img id='hitImg' ref='hitImg' :src='this.static_image_hit' alt='hit' width='600' />
    </div>

    <div id='pop' ref='popFrame'>
    </div>

    <div class='count'>
      <span>{{cybermerit_currentLang[1]}}: {{localCount}}</span><br>
      <!-- <span>{{cybermerit_currentLang[2]}}: {{globalCount}} ({{cybermerit_currentLang[3]}})</span> -->
    </div>

    <div class='mute' @click='setMute'>
      {{cybermerit_currentLang[4]}}
      <img id='muted' ref='muted' :src='this.static_image_mute' alt='mute' width='50' />
      <img id='unmuted' ref='unmuted' :src='this.static_image_unmute' alt='unmute' width='50' />
      <!-- <img id='question' src='../../../assets/images/cybermerit-question.png' alt='question' width='40' /> -->
    </div>

    <div class='audios'>
      <audio id='audio_hit' ref='audioHit'>
        <source :src='this.static_audio_hit' type="audio/mpeg">
      </audio>
    </div>
  </div>
</template>

<script>
import 'animate.css';
export default {
  name: 'mini-cybermerit',
  data () {
    return {
      static_image_default: require('../../../assets/images/cybermerit-default.png'),
      static_image_hit: require('../../../assets/images/cybermerit-hit.png'),
      static_image_mute: require('../../../assets/images/cybermerit-mute.png'),
      static_image_unmute: require('../../../assets/images/cybermerit-unmute.png'),
      static_audio_hit: require('../../../assets/audio/cybermerit-hit.wav'),
      localCount: 0,
      globalCount: 0,
      isMute: false,
      isHit: false,
      langData_cybermerit_cn: ['功德', '你的赛博功德', '全网赛博功德', '非实时更新', '在iOS设备可能无法播放声音'],
      langData_cybermerit_en: ['Merit', 'Your Cyber Merit', 'Global Cyber Merit', 'Not Updated Instantly', 'Sound may fail on iOS devices.'],
      cybermerit_currentLang: ['功德', '你的赛博功德', '全网赛博功德', '非实时更新', '在iOS设备可能无法播放声音'],
    }
  },
  methods: {
    userClick () {
      if (!this.isHit) {
        this.isHit = true;

        this.showPop();
        this.playSound();
        this.pictureSwitch();
        this.updateLocalCount();
      }
    },
    pictureSwitch () {
      this.$refs.defaultImg.style.display = 'none';
      this.$refs.hitImg.style.display = 'inline';
      setTimeout(() => {
        this.isHit = false;
        this.$refs.hitImg.style.display = 'none';
        this.$refs.defaultImg.style.display = 'inline';
      }, 100)
    },
    playSound () {
      if (!this.isMute) {
        let hitAudio = this.$refs.audioHit;
        hitAudio.play();
        setTimeout(() => {
          hitAudio.pause();
        }, 150)
      }
    },
    showPop () {
      let popup = document.createElement('p')
      popup.innerHTML = this.cybermerit_currentLang[0] + ' +1';
      popup.className = 'popup'
      this.$refs.popFrame.appendChild(popup)

      setTimeout(() => {
        popup.style.cssText = ''
        this.$refs.popFrame.removeChild(popup);
      }, 2000)
    },
    setMute () {
      this.isMute = !this.isMute;
      if (this.isMute) {
        this.$refs.muted.style.display = 'inline'
        this.$refs.unmuted.style.display = 'none'
      }
      else {
        this.$refs.muted.style.display = 'none'
        this.$refs.unmuted.style.display = 'inline'
      }
    },
    resizePicture () {
      this.$refs.defaultImg.width = 0.3 * window.innerWidth;
      this.$refs.hitImg.width = 0.3 * window.innerWidth;
    },
    updateLocalCount () {
      this.localCount++;
      localStorage.setItem('count', this.localCount);
    },
    setLang (lang) {
      if (lang == 'lang_cn') {
        this.cybermerit_currentLang = this.langData_cybermerit_cn;
      }
      else if (lang == 'lang_en') {
        this.cybermerit_currentLang = this.langData_cybermerit_en;
      }
    }
  },
  mounted () {
    this.$bus.$on('setLang', this.setLang);
    window.addEventListener('resize', this.resizePicture);
    this.resizePicture();
    if (localStorage.getItem('count')) {
      this.localCount = localStorage.getItem('count');
    }
    else {
      localStorage.setItem('count', 0);
    }
  }
}
</script>

<style scoped>
.warpper {
  position: fixed;
  background-color: rgb(0, 0, 0);
  width: 100%;
  height: 100%;
  text-align: center;
}
.title {
  text-align: center;
  font-size: 150%;
  padding: 20px 0 20px 0;
  color: aquamarine;
}
.main {
  position: relative;
  margin: 100px 0 0 0;
  text-align: center;
  z-index: 1;
}
#defaultImg {
  cursor: pointer;
}
#hitImg {
  display: none;
}
.count {
  color: aqua;
  margin: 30px 0 0 0;
  font-size: 20px;
}
.audios {
  display: hidden;
}
.mute {
  position: fixed;
  bottom: 0;
  right: 0;
  cursor: pointer;
  color: aqua;
}
#muted {
  display: none;
}
</style>

<style>
.popup {
  color: transparent;
  position: absolute;
  top: 65%;
  left: 70%;
  animation: yan 2s linear;
  z-index: 100;
  font-size: 20px;
  font-weight: bolder;
}
@keyframes yan {
  0% {
    color: transparent;
  }
  100% {
    color: aqua;
    transform: translate(0px, -300px);
  }
}
</style>